<template>
    <div class="content-wrapper">
        <div class="ibox-title">
            <h5 id="h5Title">体质数据详情</h5>
        </div>
        <div class='worker_data ibox-content' style="padding-left: 0;">
            <div class="nav_cha">体质信息</div>
            <div>
                <el-form :inline="true" :model="dataform" ref="form" label-width="120px" label-position="right"
                class="demo-form-inline" id="childPhyAdd">
                 <el-form-item label="评定标准：" prop='specId' style="width:380px">
                        <!-- <el-select v-model="dataform.specId" placeholder="请选择体检类型" :disabled="isEdit" style="width:200px">
                            <el-option v-for="item in standList" :key="item.id" :label="item.standardName" :value="item.id"  ></el-option>
                        </el-select> -->{{standName}}
                    </el-form-item>
                    <el-form-item label="测试日期：" prop='dataDate'     style="width:380px">
                        {{dataform.dataDate}}
                        <!-- <el-date-picker v-model="dataform.dataDate" value-format='yyyy-MM-dd' type="date" placeholder="选择体检日期"
                        style="width:200px" :picker-options="pickerOptions"></el-date-picker> -->
                    </el-form-item>
                    <div class="nav_cha">儿童信息</div>
                     <el-form-item label="姓名：" prop="childName"  style="width:380px">
                       <!-- <el-autocomplete v-model="dataform.childName"  style="width:200px" :disabled="isEdit"  :fetch-suggestions="searchStuByhhs" placeholder="请输入儿童姓名" value-key="childName" @select="selectChild">

                       </el-autocomplete> -->
                        {{dataform.childName}}

                    </el-form-item>

                    <el-form-item label="性别：" prop="sex" style="width:380px" id="sex">
                    <!-- <el-select v-model="dataform.sex" :disabled="isEdit" style="width:200px" placeholder=""  ref="sex">
                        <el-option key="男" label="男" value="男"></el-option>
                        <el-option key="女" label="女" value="女"></el-option>
                    </el-select> -->
                    {{dataform.sex}}
                    </el-form-item>
                    <el-form-item label="出生日期：" prop="birthday" style="width:380px" id="birthday">
                        {{dataform.birthday}}
                        <!-- <el-date-picker v-model="dataform.birthday" :disabled="disabledChildInfo||isEdit" value-format='yyyy-MM-dd' type="date" style="width:200px" > </el-date-picker> -->
                    </el-form-item>
                    <el-form-item label="身份证号码："  prop='idCard' style="width:380px">
                        {{selChild.idCard}}
                        <!-- <el-input v-model="selChild.idCard" style="width:200px" :disabled="disabledChildInfo||isEdit" ref="idCard"></el-input> -->
                    </el-form-item>
                    <el-form-item label="联系人："  prop='relation' style="width:380px">
                        {{selChild.relation}}
                        <!-- <el-input v-model="selChild.relation" style="width:200px"  :disabled="disabledChildInfo||isEdit" ref="relation"></el-input> -->
                    </el-form-item>
                    <el-form-item label="手机号码：" prop='relationPhone' style="width:380px">
                        {{selChild.relationPhone}}
                        <!-- <el-input v-model="selChild.relationPhone" style="width:200px" :disabled="disabledChildInfo||isEdit" ref="relationPhone"></el-input> -->
                    </el-form-item>
                  
                    <div class="nav_cha">测试信息</div>
                  

                    
                      <template v-if='dataform.itemMap' v-for='(item, num) in standComponents'>
                        <template v-if='item.itemType=="INPUT"'>
                            <el-form-item :label="item.itemName" style="width:380px" :key="num">
                                {{dataform.itemMap[item.itemCode]}}
                            </el-form-item>

                          <!-- <input-com :label='item.displayName' :key="num" :prop='item.itemCode' :val='dataform.itemMap[item.itemCode]' :detail='item.details'></input-com> -->
                        </template>
                      </template>
                      <div class='clear'></div>
                   
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    import api from '../../com/ajax' // ajax请求封装
    import config from '../../com/config' // url配置文件

    export default {
      data () {
        return {
            standName:'',//评定标准
          standList:[],// 标准集合
          dataform:{
            specId:'',
            itemMap:{},
            dataDate:'',
            studentId:'',
            childName:'',
            sex:'',
            birthday:'',
            dataVersion:'',
            id:''
          },
          selChild:{
            idCard:'',
            relation:'',
            relationPhone:''
          },
          standComponents:[],//标准的控件集合
          studentList:[],//学生列表
          disabledChildInfo:false,//是否禁用儿童相关信息
          isEdit:false,
          // loadingStuList:false,//搜索时候的加载中动画


          pickerOptions: {// 只能选择今天以前的日期
            disabledDate (time) {
              return time.getTime() > Date.now() - 8.64e6
            }
          }
        }
      },
      methods: {
        initStandComponents(){//初始化加载标准组件
          let self = this
          return new Promise((resolve)=>{
             self.send(config.khsHost +self.$api.getStandComponents+self.dataform.specId,{},true).then((data)=>{
           
              if(data.success){
                resolve(data)
              }
              else{
                self.$message.error('标准数据异常!')
                resolve('')
              }
            })
          })
         
        },
        getDetailById(id){//获取体质数据详情
          let self = this
          return new Promise((resolve)=>{
             self.send(config.khsHost +self.$api.getPecInfo+id,{},true).then((data)=>{
               
              if(data.success){
                resolve(data)
              }
              else{
                self.$message.error('查询数据异常!')
                resolve('')
              }
            })
          })
        },
        getChildDetailById(id){//获取儿童数据详情
          let self = this
          return new Promise((resolve)=>{
             self.send(config.host +self.$api.getChildInfo,{childID:id},false).then((data)=>{
               
              if(data.success){
                resolve(data)
              }
              else{
                self.$message.error('查询数据异常!')
                resolve('')
              }
            })
          })
        },
        send(url,pram,isGet){// 进行ajax发送
          return new Promise((resolve)=> {
            if(isGet){
              api.get( url, pram).then(function (data) {
                resolve(data)
              })
            }
            else{
              api.post( url, pram).then(function (data) {
                resolve(data)
              })
            }
          })
        }
       },
      created () {
        var self = this
        /**一、初始化部分
         * 
         * 1.加载评定标准，默认选中一项评定标准
         *  ｛
         *      根据评定标准初始化加载动态的测试信息部分控件
         *   ｝
         *    
         */

          //1.加载评定标准，默认选中一项评定标准
          self.send(config.khsHost +self.$api.getStandardList,{},true).then((data)=>{
            //判断是否有无标准，如果没有则显示需要进行添加的页面跳转
            if(data.success&&data.body.length>0){
              self.standList=data.body
              //如果有标准的话默认读取一个标准
              self.dataform.specId=self.$route.query.specId||data.body[0].id
              //如果有标准的话初始化加载动态的测试信息部分控件
              self.initStandComponents().then((data)=>{
                self.dataform.dataVersion=data.body.version
                
                if(data){

                  //获取动态标准项
                  let checkItem=data.body.items

                  let id=self.$route.query.id
                  let childId=self.$route.query.childId
                  
                  if(id&&childId){
                    self.dataform.id=id
                    self.dataform.studentId=childId
                    //获取儿童数据详情
                    self.getChildDetailById(childId).then((data)=>{
                      data=data.body.list
                      self.dataform.childName=data.childName
                      self.dataform.birthday=data.birthday
                      self.selChild.idCard=data.idCard
                      self.selChild.relation=data.relation
                      self.selChild.relationPhone=data.relationPhone
                      self.dataform.sex=data.sex
                      self.isEdit=true
                    })
                    //获取体质数据详情
                    self.getDetailById(id).then((data)=>{
                        self.standName=self.standList.filter((item)=>{
                            return item.id==self.dataform.specId
                        })[0].standardName
                      let itemMap = data.body.itemMap
                      self.dataform.dataVersion=data.body.dataVersion
                      self.dataform.dataDate=data.body.dataDate
                      checkItem.forEach(function(i, num) {
                        var value = ''
                        if (itemMap[i.itemCode]) {
                          value = itemMap[i.itemCode].value
                        }
                        self.$set(self.dataform.itemMap, i.itemCode,  value )
                        // that.oldItemMap = JSON.stringify(that.form.itemMap)
                        if (num == checkItem.length - 1) {
                          self.standComponents = checkItem
                        }
                      })
                    })

                  }
                  else{
                    // 添加的动作
                    for (let i in checkItem) {
                      var item = checkItem[i]
                      self.$set(self.dataform.itemMap, item.itemCode, { value: '' })
                    }
                    self.standComponents=checkItem
                  }

                }
              })
            }
            else{
              self.$message.error('无标准数据!')
            }
          })
      }
    }
</script>
<style>
    #childPhyAdd .el-form-item__content{
      vertical-align: top;
    }
    .nav_cha {
        padding-left: 10px;
        border-left: 5px solid #1ab394;
        height: 16px;
        line-height: 16px;
        margin: 12px;
        font-weight: bold;
        text-align: left;
    }

    .red {
        color: red;
        position: relative;
        left: 30px;
        top: 10px
    }

    .red1 {
        color: red;
        position: relative;
        left: 15px;
        top: 10px
    }

    .red2 {
        color: red;
        position: relative;
        top: 10px
    }

    .float {
        position: absolute;
        bottom: 0px;
        right: -45px;
    }

    .evaluate {
        width: 80%;
        margin-left: 27px;
    }

    .evaluate .el-form-item__content{
        width: 100%;
    }

    .hold {
        margin: auto;
        width: 200px;
    }
    .nav_gen{
        width:82%;
        height: 46px;
        line-height: 46px;
        margin: 12px;
        font-weight: bold;
        text-align: left;
    }
    .setLine{
        padding-left: 10px;
        border-left: 5px solid #1ab394;
    }
    .setBtn{
        display: inline-block;
        float : right;
    }
    .star .el-form-item__label:before{
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
    /* 选用模板弹窗 */
    .innerDialog .el-dialog{
      min-height:600px;
    }
    .module_left {
				height: 100%;
				float: left;
				width: 27%;
				min-height: 340px;
				border: 1px solid #DDDDDD;
				-webkit-box-sizing: border-box;
				-moz-box-sizing: border-box;
			}
      #dislist .el-checkbox{
        margin-left:0
      }
      #dislist li{
        list-style-type: none
      }
			.msgtit {
				border-bottom: 1px solid #DDDDDD;
				height: 38px;
				line-height: 38px;
				font-size: 16px;
				font-weight: bold;
				padding-left: 20px;
				background: #f6f6f6;
			}

      .module_right {
				position: relative;
				float: left;
				width: 73%;
        border: 1px solid #ddd;
        min-height: 340px;
			}
      #module_main{
        padding-left:20px;
      }
      #dislist .el-checkbox+.el-checkbox{
        margin-left:0;
      }
</style>


// WEBPACK FOOTER //
// src/components/physique/physiqueDetail.vue?309dadf5